import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAvailabilitiesPending } from 'redux/slices/myAvailabilitySlice';

import { tableCellClasses } from '@mui/material';
import CustomTable from 'common/features/tables/CustomTable';
import MyAvailabilityTableRow from './MyAvailabilityTableRow';

function sortDates(data) {
    const toMinutes = (time) => {
        const [h, m] = time.split(':').map(Number);
        return h * 60 + m;
    };

    const resp = {};

    Object.keys(data).forEach((key) => {
        resp[key] = [...data[key]].sort((a, b) => {
            return toMinutes(a.startTime) - toMinutes(b.startTime);
        });
    });

    return resp;
}

const MyAvailabilityTable = (props) => {
    const { availability } = props;
    const { t } = useTranslation();
    const pending = useSelector(getAvailabilitiesPending);
    const workingHours = sortDates(availability?.weeklySchedule || {}) || {};

    const tableConfig = {
        columns: [
            { id: 'sunday', content: t('app.common.days.sunday') },
            { id: 'monday', content: t('app.common.days.monday') },
            { id: 'tuesday', content: t('app.common.days.tuesday') },
            { id: 'wednesday', content: t('app.common.days.wednesday') },
            { id: 'thursday', content: t('app.common.days.thursday') },
            { id: 'friday', content: t('app.common.days.friday') },
            { id: 'saturday', content: t('app.common.days.saturday') },
        ],
        actionColumn: false,
        pending: pending,
    };

    return (
        <CustomTable
            customTableSx={{
                [`& .${tableCellClasses.root}`]: {
                    borderBottom: 'none',
                },
            }}
            tableConfig={tableConfig}
        >
            <MyAvailabilityTableRow key={1} workingHours={workingHours} />
            <div key={2} />
        </CustomTable>

        // <MyAvailabilityDayChips availability={availability} />
    );
};

export default MyAvailabilityTable;
